module.exports = __webpack_public_path__ + "img/06@2x.c96394b6.png";